import { FDStack } from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import { InfoBox } from './InfoBox';


export const InfoSection = ({ collection }) => {
  return (
    <FDStack direction={'column'} justifyContent={'center'} alignItems={'stretch'} spacing={2}>
      {collection.resources().list().map((d) => (
        <InfoBox key={d.id()} resource={d} />
      ))}
    </FDStack>
  );
};

InfoSection.propTypes = {
  collection: PropTypes.object.isRequired,
};
